// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"a24f271a","712":"b4ee6a8a","959":"a69870fa"}[chunkId] + ".chunk.css";
};